_ = require('lodash')

angular.module('workflow.app')

.factory( 'SearchWorkers', ( Collection, SearchWorker, Api, settings ) ->

  class SearchWorkers extends Collection

    getRecordClass: ->
      SearchWorker

    getApiClass: ->
      Api.SearchWorker

    onItemsChanged: ->
      super()
      @sort()
      @updateBreakdown()

    sort: ->
      super([
        ( worker ) -> worker.getResultsCount()
        ( worker ) -> worker.getName()
        ( worker ) -> worker.getPrimaryKey()
      ])

    startPolling: ( options, callback ) ->
      mergeKey = (worker) -> worker.id
      @_startPolling( options, settings.WORKER_POLLING_INTERVAL, mergeKey, ( workers ) =>
        @stopPolling() if @allHaveFinished()
        callback( workers )
      )

    initBreakdown: ->
      @breakdown =
        running:            []
        failed:             []
        accepting_results:
          all:              []
          hasResults:       []
          noResults:        []
        completed:
          all:              []
          withResults:
            all:            []
            fullResults:    []
            partialResults: []
          noResults:        []

    getBreakdown: ->
      @breakdown

    updateBreakdown: ->
      @initBreakdown()
      for worker in @
        if worker.isRunning()
          @breakdown.running.push( worker )
        else if worker.hasFailed()
          @breakdown.failed.push( worker )
        else if worker.isAcceptingResults()
          @breakdown.accepting_results.all.push( worker )
          if worker.hasResults()
            @breakdown.accepting_results.hasResults.push( worker )
          else
            @breakdown.accepting_results.noResults.push( worker )
        else
          @breakdown.completed.all.push( worker )
          if worker.hasResults()
            @breakdown.completed.withResults.all.push( worker )
            if worker.isKraken()
              @breakdown.completed.withResults.partialResults.push( worker )
            else
              @breakdown.completed.withResults.fullResults.push( worker )
          else if worker.hasFilteredResults() and worker.isKraken()
            @breakdown.completed.withResults.partialResults.push( worker )
          else
            @breakdown.completed.noResults.push( worker )

    hasLexisNexisWorker: ->
      return true for worker in @ when worker.isLexisNexis()

    resultsAvailable: () ->
      _.sum @breakdown.completed.withResults.all, (worker) ->
        worker.results_available

    # Running

    getRunning: ->
      @breakdown.running

    getRunningCount: ->
      @getRunning().length

    hasRunning: ->
      @getRunningCount() > 0

    allHaveFinished: ->
      not @hasRunning()

    getFinishedCount: ->
      @getCount() - @getRunningCount()

    # Failed

    getFailed: ->
      @breakdown.failed

    getFailedCount: ->
      @getFailed().length

    hasFailed: ->
      @getFailedCount() > 0

    # Async Workers
    hasAcceptingResults: ->
      @breakdown.accepting_results.all.length > 0

    getAcceptingResults: ->
      @breakdown.accepting_results.all

    hasHarmoniaResults: ->
      @breakdown.accepting_results.hasResults.length > 0

    # No results

    getNoResults: ->
      @breakdown.completed.noResults

    getNoResultsCount: ->
      @getNoResults().length

    hasNoResults: ->
      @getNoResultsCount() > 0

    # With results

    getWithResults: ->
      @breakdown.completed.withResults.all

    getWithResultsCount: ->
      @getWithResults().length

    hasWithResults: ->
      @getWithResultsCount() > 0

    # With full results

    getWithFullResults: ->
      @breakdown.completed.withResults.fullResults

    getWithFullResultsCount: ->
      @getWithFullResults().length

    hasWithFullResults: ->
      @getWithFullResultsCount() > 0

    # With partial results

    getWithPartialResults: ->
      @breakdown.completed.withResults.partialResults

    getWithPartialResultsCount: ->
      @getWithPartialResults().length

    hasWithPartialResults: ->
      @getWithPartialResultsCount() > 0




)
